module.exports = "<div *ngIf=\"visible\" class=\"loader-bar\">\n  <div class=\"bar\"></div>\n  <div class=\"bar\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/loader/loader.html
// module id = u2hC
// module chunks = 12